import { useEffect } from 'react';

export default function CalendlyBooking({ companyHour }) {
  useEffect(() => {
    if (companyHour) return; // Already booked, no embed needed
    // Load Calendly widget script
    const existing = document.querySelector('script[src*="calendly.com/assets/external/widget.js"]');
    if (!existing) {
      const script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      document.body.appendChild(script);
    }
  }, [companyHour]);

  if (companyHour) {
    const start = new Date(companyHour.hour_start);
    const end = new Date(companyHour.hour_end);
    const dateStr = start.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' });
    const startTime = start.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
    const endTime = end.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });

    return (
      <div className="glass p-7">
        <h2 className="font-heading text-xl text-vault-navy mb-4">Book Your Pitch Hour</h2>
        <div className="bg-emerald-50 border border-emerald-200 rounded-2xl p-6">
          <div className="flex items-center gap-3 mb-3">
            <div className="w-8 h-8 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-600 text-lg">
              ✓
            </div>
            <h3 className="font-semibold text-emerald-700 text-base">Your pitch hour is booked</h3>
          </div>
          <div className="space-y-1 text-sm text-emerald-700 ml-11">
            <div><span className="text-emerald-500">Date:</span> {dateStr}</div>
            <div><span className="text-emerald-500">Time:</span> {startTime} – {endTime}</div>
          </div>
          <p className="text-xs text-emerald-500 mt-4 ml-11">
            Inventors who match with you will receive booking notifications starting tomorrow morning.
          </p>
        </div>
      </div>
    );
  }

  const calendlyUrl = process.env.REACT_APP_CALENDLY_URL || 'https://calendly.com/playventr/pitch-event-hour';

  return (
    <div className="glass p-7">
      <h2 className="font-heading text-xl text-vault-navy mb-2">Book Your Pitch Hour</h2>
      <p className="text-sm text-gray-400 mb-5 leading-relaxed">
        Choose a 1-hour window during the event when you'll be available to receive inventor pitches.
        Inventors who match with you will book 15-minute slots within your chosen hour.
      </p>
      <div
        className="calendly-inline-widget rounded-2xl border-2 border-vault-border overflow-hidden"
        data-url={calendlyUrl}
        style={{ minWidth: 320, height: 700 }}
      />
      <p className="text-xs text-gray-400 mt-3 text-center">
        After booking, your availability will appear here within a few minutes.
      </p>
    </div>
  );
}
